import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import { DataState } from '@/types/data.type';
import { Reel } from '@/types/reel.type';

import { FlowMapItem, LibrarySliceState } from './library.type';

const libraryInitialState: LibrarySliceState = {
    flowMap: {},
    reelMap: {},
    reelStateMap: {},
};

export const LIBRARY_REDUCER_NAME = 'library';

export const librarySlice = createSlice({
    name: LIBRARY_REDUCER_NAME,
    initialState: libraryInitialState,
    reducers: {
        setFlowsByReelCode: (
            state,
            action: PayloadAction<{
                reelCode: string;
                flows: FlowMapItem[];
            }>,
        ) => {
            state.flowMap[action.payload.reelCode] = action.payload.flows;
        },
        setReelByCode: (
            state,
            action: PayloadAction<{
                reelCode: string;
                reel: Reel;
            }>,
        ) => {
            state.reelMap[action.payload.reelCode] = action.payload.reel;
        },
        patchReelByCode: (
            state,
            action: PayloadAction<{
                reelCode: string;
                patch: Partial<Reel>;
            }>,
        ) => {
            const reel = state.reelMap[action.payload.reelCode];

            if (reel) {
                Object.assign(reel, action.payload.patch);
            }
        },
        setReelState: (
            state,
            action: PayloadAction<{
                reelCode: string;
                state: DataState;
            }>,
        ) => {
            state.reelStateMap[action.payload.reelCode] = action.payload.state;
        },
        clearReelByCode: (
            state,
            action: PayloadAction<{
                reelCode: string;
            }>,
        ) => {
            delete state.reelMap[action.payload.reelCode];
            delete state.reelStateMap[action.payload.reelCode];
        },
    },
});

export const {
    setFlowsByReelCode,
    setReelByCode,
    patchReelByCode,
    setReelState,
    clearReelByCode,
} = librarySlice.actions;

export const libraryReducer = librarySlice.reducer;
